import React from 'react'
import styled from 'styled-components'
import { useSpring, animated } from 'react-spring'

export default styled(function ({ className, current = 0, total }) {
    const style = useSpring({ width: total ? `${(current / total) * 100}%` : '0%' })

    return (
        <div className={className}>
            <animated.div style={style} />
        </div>
    )
})`
    > div {
        height: 3px;
        background-color: #37a3ef;
    }
`
